import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getCasinoProfitLossBets = createAsyncThunk(
  "getCasinoProfitLossBets",
  async (payload, thunkAPI) => {
    try {
      console.log("payload", payload)
      const response = await api.post("user/profit-loss", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getCasinoProfitLossBetsSlice = createSlice({
  name: "getCasinoProfitLossBets",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCasinoProfitLossBets.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCasinoProfitLossBets.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCasinoProfitLossBets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getCasinoProfitLossBetsSlice.reducer;
